/* Global imports. */
import React from "react";
import { Slice } from "gatsby";

interface Props {
  children: any;
}

const Layout = ({ children }: Props) => {
  return (
    <>
    <Slice alias="Header" />
        {children}
    <Slice alias="Footer" />
    </>
  )
};

export default Layout;
